import dayjs from "dayjs";

interface AxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: unknown;
  };
}

const CustomXAxisTick = ({ x, y, payload }: AxisTickProps) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dx={-30} dy={4} transform="rotate(270)" textAnchor="middle" fill="#66768D">
        {dayjs(payload?.value as string).format("DD-MMM-YY")}
      </text>
    </g>
  );
};

export default CustomXAxisTick;